module.exports = __webpack_public_path__ + "static/img/MGVAGVimg.70f9309.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/MGVAGVimg.png
// module id = 6l4+
// module chunks = 1